/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_Fix_Total_Max_CharsInputs */



/**
* | output |
* | --- |
* | "Too many characters" |
*
* @param {Qc_Fix_Total_Max_CharsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_fix_total_max_chars = /** @type {((inputs?: Qc_Fix_Total_Max_CharsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Fix_Total_Max_CharsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Trop de caractères")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zu viele Zeichen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Troppi caratteri")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Слишком много символов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Demasiados caracteres")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字符过多")
	if (locale === "ja") return /** @type {LocalizedString} */ ("文字数が多すぎます")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बहुत अधिक वर्ण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Demasiados caracteres")
	return /** @type {LocalizedString} */ ("Too many characters")
});